<template>

  <tr v-if="ticket.package_options && ticket.package_options.length > 0">
    <td colspan="6">
      <div class="card-extras">
        <div  class="card" v-for="(option, index) in ticket.package_options">
            <div class="card-header hg-underline" :style="underlineOverride">
              {{option.title}}
            </div>
            <div class="card-body">

              <b-form-group size="medium">
                <b-radio-group stacked value-field="id" text-field="title" v-model="optionsSelected[index]" :name="'subOption_' + ticket.id + '_' + index" @change="updateTicket" :options="option.package_sub_options">
                </b-radio-group>
              </b-form-group>

          </div>
        </div>
      </div>
    </td>
  </tr>

</template>

<script>
export default {
  props: ["ticket", "event"],

  data: function() {
    return {
      free_event: false,
      optionsSelected: [],
      readonly: false,
      menuOptions: []
    };
  },

  computed: {
    underlineOverride() {
      return {
        borderBottom: "4px solid " + this.event.phcolour
      };
    }
  },

  created() {
    //  set options selected to match what comes from the package options
    if (this.ticket.sub_options_selected) {
      this.optionsSelected = this.ticket.sub_options_selected;
    }

    if(this.ticket.package_options.length > 0) {
      this.menuOptions = this.ticket.package_options;
      this.menuOptions.sort((a,b) => (a.id > b.id) ? 1 : ((b.id > a.id) ? -1 : 0));
    }
  },

  methods: {
    updateTicket() {
      this.ticket.optionsSelected = this.optionsSelected;
    }
  }
};
</script>
